import { ReactNode, useEffect, useLayoutEffect } from "react";
import { setMetaThemeColor, resetMetaThemeColor } from "@/models/useTheme";
import { useUserSlice } from "@/models/useUserSlice";
import { useRouter } from "@/_router";

type WebContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  disableBottomSafeArea?: boolean; // Kept for API compatibility with NativeContainer
  themeColor?: string;
};

const WebContainer = ({
  children,
  className = "",
  disableBottomSafeArea = false,
  themeColor,
  ...props
}: WebContainerProps) => {
  const router = useRouter();

  useEffect(() => {
    if (router.query.checkout_success === "true") {
      useUserSlice
        .getState()
        .subscription()
        .onStripeCheckoutSuccess({ router });
    }
  }, [router.query.checkout_success]);

  // Update meta theme-color whenever themeColor changes (no reset between changes)
  useLayoutEffect(() => {
    if (!themeColor) return;
    setMetaThemeColor(themeColor);
  }, [themeColor]);

  // Only reset on unmount
  useLayoutEffect(() => {
    return () => {
      resetMetaThemeColor();
    };
  }, []);

  useEffect(() => {
    useUserSlice.getState().subscription().status();
  }, []);

  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
};

export default WebContainer;
